<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center justify-content-between">
          <h1 class="h3 mb-3 text-gray-800">
            {{ $t("Equipe SUAS") }}
          </h1>

          <b-button-group v-if="!loading">
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
            <b-button variant="outline-dark" @click="print()">
              <i class="fas fa-print"></i>
            </b-button>
            <b-button
              variant="outline-dark"
              @click="exportar()"
              :title="$t('Exportar para Excel')"
              v-b-tooltip.hover
            >
              <i class="fas fa-file-download"></i>
            </b-button>
          </b-button-group>
        </div>
        <div class="alert alert-info" v-if="selected.length > 0">
          <h5>Foram selecionados {{ selected.length }} técnicos</h5>
          <ul>
            <li class="mb-2">
              Apenas os técnicos exibidos nesta página foram selecionados a ação só
              atualiza os itens selecionados.
            </li>
            <li class="mb-2">
              Ao <b class="text-danger">DESATIVAR</b> os técnicos selecionados usando a
              opção de selecionar todos, será desconsiderado os já <b>Desativados</b>.
            </li>
            <li class="mb-2">
              Ao <b class="text-success">ATIVAR</b> os técnicos selecionados usando a
              opção de selecionar todos, será desconsiderado os já <b>ativados</b>.
            </li>
          </ul>
        </div>
      </div>
    </div>

    <b-card class="shadow">
      <div class="list-tecnicos-component">
        <div class="row">
          <div class="col-12">
            <div
              class="d-flex align-items-center justify-content-between mb-4"
              v-if="!loading"
            >
              <router-link class="btn btn-primary" to="/dashboard/tecnicos/add">
                <i class="fas fa-plus-square" />
                {{ $t("Cadastrar") }}
              </router-link>

              <span class="d-flex justify-content-start align-items-cente">
                <span
                  v-if="selected.length < perPage"
                  class="d-flex align-items-center"
                  @click.prevent="selectAllRows()"
                >
                  <toggle-button
                    color="#5685D8"
                    :value="false"
                    :disabled="true"
                    :sync="true"
                  />
                  <span class="mx-2">Selecionar todos</span>
                </span>
                <span
                  class="d-flex align-items-center"
                  @click.prevent="clearSelected()"
                  v-else
                >
                  <toggle-button
                    color="#5685D8"
                    :value="true"
                    :disabled="true"
                    :sync="true"
                  />
                  <span class="mx-2">Desmarcar todos</span>
                </span>
                <span v-if="$store.state.user.role_details.name == 'Admin'">
                  <button
                    class="btn btn-danger mb-0"
                    v-if="selected.length > 0"
                    @click.prevent="openModalMotivoDesativar"
                  >
                    <i class="fas fa-ban"></i>
                    Desativar Técnico(s)
                  </button>
                  <button
                    class="btn btn-success mb-0"
                    v-if="selected.length > 0"
                    @click.prevent="atualizarTecnicos('ativar')"
                  >
                    <i class="fas fa-check-circle"></i>
                    Ativar Técnico(s)
                  </button>
                </span>
              </span>
            </div>
          </div>

          <div class="col-12" v-if="viewFilterReport">
            <form @submit.prevent="getTecnicos" ref="formFiltros">
              <div class="row">
                <div class="col-md-12">
                  <label><b>Pesquisar</b></label>
                  <div class="input-group">
                    <b-input
                      placeholder="No campo acima você pode pesquisar por: Nome Completo, E-mail e Telefone"
                      class="form-control search-input"
                      type="text"
                      v-model="search"
                      aria-describedby="input-search"
                    />
                    <div
                      class="input-group-append"
                      role="button"
                      @click.prevent="getTecnicos"
                    >
                      <span class="input-group-text" id="input-search"
                        ><i class="fas fa-search search-icon"
                      /></span>
                    </div>
                  </div>
                  <p class="small text-muted">
                    No campo acima você pode pesquisar por: Nome Completo, E-mail
                    e Telefone
                  </p>
                </div>

                <form-select
                  v-model="filtroUnidades"
                  label="Filtrar por Unidade"
                  grid="6"
                  :itens="unidades"
                  :disabled="loadingSearchUnidade"
                  :loading="loadingSearchUnidade"
                  :multiple="true"
                  placeholder="Pesquise o nome de uma Unidade."
                />

                <form-select
                  grid="6"
                  v-model="filtroRoles"
                  :itens="roles"
                  placeholder="Selecione uma Função"
                  label="Função na Unidade/Sistema"
                  :multiple="true"
                />

                <form-calendar v-model="data_inicio" grid="4" label="Data Inicial" />

                <form-calendar
                  v-model="data_fim"
                  grid="4"
                  label="Data Final"
                  :required="verificaDataInicial"
                />

                <form-select
                  v-model="filtroStatus"
                  grid="4"
                  label="Status"
                  :itens="status"
                />
              </div>
              <div class="row pt-2 mb-4 px-0 d-flex justify-content-end">
                <div class="col-auto px-2 text-right">
                  <button
                    class="btn btn-default btn-sm"
                    @click.prevent="
                      limparFiltros();
                      viewFilterReport = false;
                    "
                  >
                    <i class="fas fa-times"></i>
                  </button>

                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    @click.prevent="limparFiltros()"
                  >
                    {{ $t("Limpar Filtros") }}
                  </button>
                  <button
                    class="btn btn-success btn-submit btn-sm"
                    data-style="zoom-in"
                    type="submit"
                  >
                    <i class="fas fa-chart-bar"></i>
                    {{ $t("Filtrar") }}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <load v-if="loading" mode="table" message="Carregando técnicos" />
          <div v-else class="col-12">
            <!-- <loading-animation
                            :active.sync="loading"
                            :is-full-page="false"
                            :opacity="1"
                            color="#5895FF"
                        /> -->
            <print-content>
              <template v-slot:datas>
                <p v-if="datas.start">
                  Período de pesquisa selecionado:
                  <b>{{ datas.start }} - {{ datas.end }}</b>
                  <b-link
                    href="#"
                    @click.prevent="void 0"
                    class="mb-2"
                    variant="info"
                    v-b-popover.hover.top="
                      'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                    "
                  >
                    <i class="fas fa-info-circle"></i>
                  </b-link>
                </p>
              </template>
              <b-table
                :fields="[
                  {
                    key: 'selected',
                    label: 'Selecione',
                    class: 'text-center no-print',
                    thStyle: {
                      width: '100px',
                      minWidth: '100px',
                    },
                  },
                  {
                    key: 'nome',
                    label: $t('Nome'),
                  },
                  {
                    key: 'unidade',
                    label: $t('Unidade'),
                  },
                  {
                    key: 'role',
                    label: $t('Role'),
                  },
                  {
                    key: 'status',
                    label: $t('Status'),
                  },
                  {
                    key: 'actions',
                    label: '',
                    class: 'text-right no-print',
                    thStyle: {
                      width: '100px',
                      minWidth: '100px',
                    },
                  },
                ]"
                :items="tecnicosList"
                responsive="sm"
                :select-mode="selectMode"
                striped
                hover
                stacked="xs"
                show-empty
                small
                outlined
                table-class="mb-3"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
              >
                <template #cell(selected)="{ rowSelected }">
                  <div class="d-flex justify-content-center">
                    <template v-if="rowSelected">
                      <toggle-button color="#5685D8" :value="true" :sync="true" />
                    </template>
                    <template v-else>
                      <toggle-button :value="false" :disabled="true" :sync="true" />
                    </template>
                  </div>
                </template>
                <template v-slot:cell(nome)="data">
                  <span v-html="$options.filters.highlight(data.item.nome, search)">
                  </span>
                  <span
                    class="text-muted small d-block"
                    v-html="$options.filters.highlight(data.item.email, search)"
                  >
                  </span>
                  <span
                    class="text-muted small d-block"
                    v-html="$options.filters.highlight(data.item.telefone, search)"
                  >
                  </span>
                  <span class="text-muted small d-block">
                    Criado em: {{ data.item.cadastro }}
                  </span>
                </template>
                <template v-slot:cell(unidade)="data">
                  {{ data.item.unidade.name }}
                </template>
                <template v-slot:cell(role)="data">
                  {{ data.item.role.value }}
                </template>
                <template v-slot:cell(status)="data">
                  <span v-html="data.item.status_nome"></span>
                  <span v-if="data.item.status_nome_sem_formatacao == 'INATIVO'">
                    <b-popover
                      v-if="data.item.historicos"
                      :target="`popover-target-${data.item.historicos.id}`"
                      triggers="hover"
                      placement="top"
                    >
                      <b>Data: </b>{{ data.item.historicos.data_atualizacao }}<br />
                      <template v-if="data.item.historicos.motivo">
                        <b>Motivo: </b>{{ data.item.historicos.motivo.descricao }}<br />
                      </template>
                      <b>Observação: </b>{{ data.item.historicos.observacoes }}
                    </b-popover>

                    <i
                      v-if="data.item.historicos"
                      class="fas text-danger fa-info-circle"
                      :id="`popover-target-${data.item.historicos.id}`"
                    ></i>
                  </span>
                </template>
                <template v-slot:cell()="data">
                  <div size="sm" class="d-flex justify-content-end align-items-center">
                    <b-button
                      v-if="data.item.count_atendimentos > 0"
                      @click="remanejarAtendimentos(data.item.id)"
                      class="px-2 mb-0 mr-2"
                      size="sm"
                      type="button"
                      v-b-tooltip.hover
                      variant="info"
                      title="Remanejar Atendimentos"
                    >
                      <i class="fas fa-share"></i>
                    </b-button> 
                    <b-button
                      :title="$t('Editar Técnico')"
                      :to="'/dashboard/tecnicos/edit/' + data.item.id"
                      class="px-2 mb-0 mr-2"
                      size="sm"
                      type="button"
                      v-b-tooltip.hover
                      variant="success"
                    >
                      <i class="fas fa-edit"></i>
                    </b-button>
                    <b-button
                      title="Expirar senha"
                      variant="danger"
                      v-b-tooltip.hover
                      class="px-2 mb-0 mr-2"
                      size="sm"
                      type="button"
                      v-if="isAdmin"
                      @click="expirarSenha(data.item.id)"
                    >
                      <i class="fas fa-clock"></i>
                    </b-button>
                  </div>
                </template>
                <template v-slot:empty="scope" v-if="!loading">
                  <div class="text-center my-5">
                    <img
                      :alt="$t('No results')"
                      class="mb-5"
                      src="/img/icons/robot.svg"
                      style="max-height: 165px"
                    />
                    <h3 class="bold">
                      {{ $t("No records found") }}
                    </h3>
                  </div>
                </template>
              </b-table>
            </print-content>
            <div class="row align-items-center">
              <div class="col-lg-6 col-md-12">
                <div class="form-group d-inline-flex mb-0">
                  <select
                    class="form-control"
                    style="width: 70px"
                    v-model="perPage"
                    v-on:change="getTecnicos"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  </select>
                </div>
                <div class="d-inline-flex ml-2">
                  <b-pagination
                    :per-page="perPage"
                    :total-rows="pagination.total"
                    @change="changePage"
                    v-model="page"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                <div class="float-lg-right">
                  {{ $t("Showing page") }}
                  {{ pagination.currentPage }}
                  {{ $t("of") }}
                  {{ pagination.totalPages }}
                  {{ $t("pages in") }}
                  {{ pagination.total }}
                  {{ $t("records") }}
                </div>
              </div>
            </div>
          </div>
          <router-view />
        </div>
      </div>
    </b-card>
    <remanejar-atendimento
      :tecnico="tecnico_selected_id"
      @limpar="tecnico_selected_id = 0"
    />
    <status-historico
      model="Tecnico"
      modulo="Tecnico"
      titulo_modulo="TÉCNICO"
      :multiplo="true"
      :id="selectedAtivos"
      :status-anterior="status_ativo"
      :status-atual="status_inativo"
      :status="status"
      @submit="atualizarTecnicos('desativar')"
    />
  </div>
</template>

<script>
export default {
  name: "Tecnicos",
  metaInfo() {
    return {
      title: this.$i18n.t("Equipe SUAS"),
    };
  },
  data() {
    return {
      status_ativo: 0,
      status_inativo: 0,
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      tecnicosList: [],
      tecnico_selected_id: "",
      loadingSearchUnidade: false,
      status: {},
      unidades: [],
      roles: [],
      datas: {},
      filtroStatus: null,
      filtroDatas: [],
      filtroUnidades: null,
      filtroRoles: null,
      selectMode: "multi",
      selected: [],
      selectedAtivos: [],
      sel: false,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.user.role_details.name == "Admin";
    },
  },
  mounted() {
    this.getStatus();
    this.getUnidades();
    this.getRoles();
    this.getTecnicos();
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.pagination.totalPages && page !== this.page) {
        this.page = page;
        this.getTecnicos();
      }
    },
    getTecnicos() {
      this.loading = true;

      this.datas.start = this.$options.filters.formatDate(this.data_inicio);
      this.datas.end = this.$options.filters.formatDate(this.data_fim);

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      axios
        .get("api/dashboard/tecnicos", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroUnidades: this.filtroUnidades,
            filtroRoles: this.filtroRoles,
          },
        })
        .then((response) => {
          this.tecnicosList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getTecnicos();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    remanejarAtendimentos(id) {
      this.tecnico_selected_id = id;
      this.$bvModal.show("modal-remanejar-atendimento");
    },
    // deleteTecnico(id) {
    //   swal
    //     .fire({
    //       title: this.$t("Are you sure?"),
    //       showCancelButton: true,
    //       cancelButtonText: this.$t("Cancel"),
    //       confirmButtonText: this.$t("Delete"),
    //       icon: "warning",
    //     })
    //     .then((value) => {
    //       if (value) {
    //         this.loading = true;
    //         axios
    //           .delete("api/dashboard/tecnicos/" + id)
    //           .then((response) => {
    //             this.getTecnicos();
    //             this.$snack.success({
    //               button: false,
    //               text: response.data.data.message,
    //             });
    //           })
    //           .catch(() => {
    //             this.loading = false;
    //           });
    //       }
    //     });
    // },
    expirarSenha(id) {
      swal
        .fire({
          title: this.$t("Are you sure?"),
          text: "A senha do técnico será expirada e ele receberá um e-mail para redefinição de senha no próximo login.",
          showCancelButton: true,
          cancelButtonText: this.$t("Cancel"),
          confirmButtonText: this.$t("Expire"),
          icon: "warning",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.loading = true;
            axios
              .post(`api/dashboard/tecnico/expirar-senha/${id}`)
              .then((response) => {
                this.$snack.success({
                  button: false,
                  text: response.data.data.message,
                });
              })
              .catch(() => {
                this.loading = false;
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
    },
    limparFiltros() {
      this.search = "";
      this.filtroStatus = null;
      this.filtroDatas = [];
      this.filtroUnidades = [];
      this.filtroRoles = [];
      this.data_inicio = "";
      this.data_fim = "";
      this.getTecnicos();
    },
    getStatus() {
      axios.get(`api/dashboard/status/tecnicos`).then((response) => {
        this.status = response.data;
        if (this.status) {
          this.status_ativo = this.status[0].id;
          this.status_inativo = this.status[1].id;
        }
      });
    },
    getRoles() {
      axios.get("api/dashboard/users/roles").then((response) => {
        if (response.data.data) {
          this.roles = response.data.data.map((elem) => ({
            id: elem.id,
            value: elem.name,
          }));
        }
      });
    },
    getUnidades() {
      this.loadingSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => (this.loadingSearchUnidade = false));
    },
    exportar() {
      this.loading = true;
      swal.fire({
        title: "Aguarde",
        text: "O Arquivo está sendo gerado.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/tecnicos", {
          params: {
            exportarExcel: "ok",
          },
        })
        .then((response) => {
          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => (this.loading = false));
    },
    onRowSelected(items) {
      const itens = items.map((elem) => elem.user_id);
      let selectedAtivos = [];
      items.map((elem) => {
        if (elem.status == this.status_ativo) {
          selectedAtivos.push(elem.user_id);
        }
      });
      this.selected = itens;
      this.selectedAtivos = selectedAtivos;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    openModalMotivoDesativar() {
      this.$bvModal.show("status-historico-Tecnico");
    },
    atualizarTecnicos(tipo) {
      this.loading = true;
      axios
        .post("api/dashboard/tecnicos/ativar", {
          ids: this.selected,
          tipo: tipo,
        })
        .then((response) => {
          this.getTecnicos();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.btn-sm,
.btn-group-sm > .btn {
  padding: 5px 9px !important;
  font-size: 12px;
}
</style>
